<template>
  <div>
    <div class="ts-flex ts-justify-between">
      <a-radio-group
        :default-value="2"
        button-style="solid"
        v-model="approveStatusId"
        @change="fetchData()"
      >
        <a-radio-button
          v-for="(status, index) in approveStatus"
          :key="index"
          :value="status.value"
        >
          {{ status.label }}
        </a-radio-button>
      </a-radio-group>
      <ts-input
        v-tooltip="$t('approvalRequest.search')"
        v-model="search"
        :placeholder="$t('search')"
        style="width: 250px;"
        class="inline-block"
      />
    </div>
    <ts-loading-banner :loading="loading">
      <div class="ts-rounded-md ts-overflow-hidden ts-mt-3">
        <table class="ts-w-full">
          <thead>
            <tr>
              <th
                class="ts-bg-gray-200 ts-px-3 ts-py-1 ts-uppercase ts-w-10 ts-border-r ts-border-blue-700 ts-whitespace-no-wrap"
              >
                {{ $t('approvalRequest.requestStatus') }}
              </th>
              <th
                class="ts-bg-gray-200 ts-px-3 ts-py-1 ts-uppercase ts-border-r ts-border-blue-700 ts-w-40"
              >
                {{ $t('approvalRequest.requestDate') }}
              </th>
              <th
                class="ts-bg-gray-200 ts-px-3 ts-py-1 ts-uppercase ts-border-r ts-border-blue-700 ts-w-48"
              >
                {{ $t('approvalRequest.requestBy') }}
              </th>
              <th
                class="ts-bg-gray-200 ts-px-3 ts-py-1 ts-uppercase ts-border-r ts-border-blue-700 ts-w-56"
              >
                {{ $t('approvalRequest.origCommune') }}
              </th>
              <th
                class="ts-bg-gray-200 ts-px-3 ts-py-1 ts-uppercase ts-border-r ts-border-blue-700 ts-w-56"
              >
                {{ $t('approvalRequest.commune') }}
              </th>
              <th
                class="ts-bg-gray-200 ts-px-3 ts-py-1 ts-uppercase ts-border-r ts-border-blue-700 ts-w-24 ts-whitespace-no-wrap"
              >
                {{ $t('approvalRequest.arriveTime') }}
              </th>
              <th
                class="ts-bg-gray-200 ts-px-3 ts-py-1 ts-uppercase ts-border-r ts-border-blue-700 ts-w-8 ts-whitespace-no-wrap"
              >
                {{ $t('approvalRequest.durationTime') }}
              </th>
              <th class="ts-bg-gray-200 ts-px-3 ts-py-1 ts-uppercase">
                {{ $t('approvalRequest.comment') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="ts-border-b ts-border-gray-200"
              v-for="(item, index) in resources"
              :key="index"
            >
              <td class="ts-px-3 ts-py-1">
                {{ item.request_status == 2 ? 'Change' : 'Add New' }}
              </td>
              <td class="ts-px-3 ts-py-1">{{ item.requested_date }}</td>
              <td class="ts-px-3 ts-py-1">{{ item.request_by_name }}</td>
              <td class="ts-px-3 ts-py-1">{{ item.ori_commune_name }}</td>
              <td class="ts-px-3 ts-py-1">{{ item.commune_name }}</td>
              <td class="ts-px-3 ts-py-1">{{ item.arrival_time }}</td>
              <td class="ts-px-3 ts-py-1">
                {{ item.duration_in_minute + ' minutes' }}
              </td>
              <td class="ts-px-3 ts-py-1">{{ item.request_comment }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'historyList',
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapState('hr/approvalRequest', ['resources', 'pagination']),
    approveStatus() {
      return [
        { value: 2, label: 'Approved' },
        { value: 1, label: 'Partially Approved' },
        { value: 3, label: 'Rejected' }
      ]
    },
    search: {
      get() {
        return this.$store.state.hr.approvalRequest.search
      },
      set(newValue) {
        this.$store.commit('hr/approvalRequest/SET_SEARCH', newValue)
        this.$store.commit('hr/approvalRequest/RESET_CURRENT_PAGE')
      }
    },
    approveStatusId: {
      get(){
        return this.$store.state.hr.approvalRequest.approve_status
      },
      set(newValue) {
        this.$store.commit('hr/approvalRequest/SET_APPROVE_STATUS', newValue)
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData(attributes = {}) {
      this.loading = true
      this.$store
        .dispatch('hr/approvalRequest/historyFetch', attributes)
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    }
  },
  watch: {
    search: debounce(function() {
      this.fetchData()
    }, 500)
  }
}
</script>
